<template>
  <div class="logo-loading">
    <img
      :src="zazos.logoPath.value"
      alt="zazos"
      class="logo-loading__image"
    >

    <v-progress-linear
      class="logo-loading__progress"
      color="#ff503f"
      bg-color="#000"
      indeterminate
      height="8"
      rounded
    />
  </div>
</template>

<script lang="ts" setup>
const zazos = useZazos();
</script>

<style>
.logo-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 100%;
}

.logo-loading__image {
  margin-bottom: 10px;
  width: 100%;
  max-width: 200px;
}

.logo-loading__progress {
  opacity: 0.7;
  max-width: 200px;
}
</style>
